import { requestJson } from "./quizApiClient";

export const createQuizSession = async ({ sessionId, headers }) => {
  return requestJson("/api/quiz/session/new", {
    method: "POST",
    headers: {
      ...headers,
      ...(sessionId ? { "x-session-id": sessionId } : {}),
    },
    body: {},
  });
};

export const startQuizSession = async ({ topicId, sessionId, userId, reset = false, headers }) => {
  return requestJson("/api/quiz/start", {
    method: "POST",
    headers: {
      ...headers,
      ...(userId ? { "x-user-id": userId } : {}),
      // ...(sessionId ? { "x-session-id": sessionId } : {}),
    },
    body: {
      topic_id: topicId,
      ...(reset ? { reset: true } : {}),
      ...(!reset && sessionId ? { session_id: sessionId } : {}),
    },
  });
};

export const answerQuizSession = async ({ state, userAnswer, userId, sessionId, headers }) => {
  return requestJson("/api/quiz/answer", {
    method: "POST",
    headers: {
      ...headers,
      ...(userId ? { "x-user-id": userId } : {}),
      // ...(sessionId ? { "x-session-id": sessionId } : {}),
    },
    body: {
      state,
      user_answer: userAnswer,
      user_id: userId,
      session_id: sessionId,
    },
  });
};

export const fetchFreshQuestion = async ({ payload, userId, sessionId, headers }) => {
  return requestJson("/api/quiz/start", {
    method: "POST",
    headers: {
      ...headers,
      ...(userId ? { "x-user-id": userId } : {}),
      ...(sessionId ? { "x-session-id": sessionId } : {}),
    },
    body: payload,
  });
};

export const batchQuizQuestions = async ({ topicId, count = 5, headers }) => {
  return requestJson("/api/quiz/batch", {
    method: "POST",
    headers,
    body: { topic_id: topicId, count },
  });
};

export const getQuizTopicProgress = async ({ topicId, userId, headers }) => {
  if (!topicId) {
    throw new Error("topicId requerido");
  }

  return requestJson(`/api/quiz/progress/${topicId}`, {
    method: "GET",
    headers: {
      ...headers,
      ...(userId ? { "x-user-id": userId } : {}),
    },
  });
};

export const completeQuizSession = async ({ sessionId, userId, headers }) => {
  if (!sessionId) {
    throw new Error("sessionId requerido");
  }

  return requestJson(`/api/quiz/${sessionId}/complete`, {
    method: "POST",
    headers: {
      ...headers,
      ...(userId ? { "x-user-id": userId } : {}),
    },
    body: {},
  });
};

export const resetQuizTopicProgress = async ({ topicId, userId, headers }) => {
  if (!topicId) {
    throw new Error("topicId requerido");
  }
  if (!userId) {
    throw new Error("userId requerido");
  }

  return requestJson("/api/quiz/reset", {
    method: "POST",
    headers: {
      "x-api-key": headers?.["x-api-key"] || "sk_admin_2b136e74df7d426f464d277460c2fe7dee55c339ace8db96068061b535735f3d",
    },
    body: {
      topic_id: topicId,
      user_id: userId,
    },
  });
};
